import { useState, useSyncExternalStore } from 'react'

const useLocalStorage = (key, initialValue) => {
  const [, setLocalState] = useState(getSnapshot)
  const subscribe = handleChange => {
    window.addEventListener('storage', handleChange)
    return () => window.removeEventListener('storage', handleChange)
  }

  function getSnapshot() {
    try {
      const item = localStorage.getItem(key)
      if (item === null) return initialValue
      return item
    } catch (error) {
      console.error('Error reading localStorage:', error)
      return initialValue
    }
  }

  const setLocalStorageValue = newValue => {
    const valueToStore = typeof newValue === 'string' ? newValue : JSON.stringify(newValue)
    try {
      localStorage.setItem(key, valueToStore)
      setLocalState(newValue)
    } catch (error) {
      console.error('Error writing to localStorage:', error)
    }
  }

  const getServerSideSnapshot = () => {
    return initialValue
  }

  const state = useSyncExternalStore(subscribe, getSnapshot, getServerSideSnapshot)

  return [state, setLocalStorageValue]
}

export default useLocalStorage
